import { render, staticRenderFns } from "./btns-text-block-edit.vue?vue&type=template&id=b9c0caf2&"
import script from "./btns-text-block-edit.vue?vue&type=script&lang=js&"
export * from "./btns-text-block-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports